// 组件对象，大写
import panguDraggableList from './panguDraggableList.vue'
export default panguDraggableList
